import { format, isValid } from 'date-fns';

import type { ScheduledDropResponse } from '~entities/scheduled-drops/api/get-scheduled-drops';

import { parseToNoonDate } from '~shared/helpers/datetime';

export function formatScheduledDropDate(dateString: string): string {
  try {
    const atNoon = parseToNoonDate(dateString);
    if (atNoon == null || !isValid(atNoon)) {
      return '—';
    }

    return format(atNoon, 'MMM dd, yyyy');
  } catch (error) {
    console.error('Failed to format scheduled drop date', {
      dateString,
      error,
    });
    throw error;
  }
}

export function isScheduledDropDateRangeInvalid(
  dateFrom: string,
  dateTo: string,
): boolean {
  try {
    if (!dateFrom || !dateTo) {
      return false;
    }

    return dateFrom > dateTo;
  } catch (error) {
    console.error('Failed to validate scheduled drop date range', {
      dateFrom,
      dateTo,
      error,
    });
    throw error;
  }
}

export function formatScheduledDropStudentName(
  drop: ScheduledDropResponse,
): string {
  try {
    if (drop.student) {
      return `${drop.student.firstName} ${drop.student.lastName}`.trim();
    }

    return drop.studentId;
  } catch (error) {
    console.error('Failed to format scheduled drop student name', {
      dropId: drop.id,
      error,
    });
    throw error;
  }
}
